<template>
  <div class="living-options-packages">
    <div class="row">
      <div class="col-12">
        <div class="packages">
          <h3>Packages</h3>
          <button class="btn btn-sm btn-primary mb-4" @click="addPackage">
            Add Package
          </button>

          <div class="mb-2">
            <input
              class="form-control"
              type="text"
              v-model="packageFilterText"
              placeholder="Filter packages"
            />
          </div>
          <v-table
            :columns="[
              {
                label: 'Label',
                field: 'label',
              },
              {
                label: 'Lot',
                field: 'property',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row) {
                      return '-';
                    } else {
                      return renderPropertyCell(row);
                    }
                  },
                },
              },
              {
                label: 'House',
                field: 'dwelling',
                options: {
                  sortable: true,
                  return: function (row) {
                    if (!row) {
                      return '-';
                    } else {
                      return renderDwellingCell(row);
                    }
                  },
                },
              },
              {
                label: 'Price',
                field: 'price',
                options: {
                  sortable: true,
                  return: function (fieldValue) {
                    if (!fieldValue) {
                      return '-';
                    } else {
                      return fieldValue.toLocaleString('en-AU', {
                        style: 'currency',
                        currency: 'AUD',
                        maximumSignificantDigits: 10,
                      });
                    }
                  },
                },
              },
            ]"
            :rows="filteredPackages"
            :show-active-toggle="
              activeUser.access.indexOf('live-toggle') !== -1
            "
            save-action="SAVE_PACKAGE"
            @edit="editPackage($event._id)"
            @clone="clonePackage($event)"
            @delete="deletePackage($event._id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VTable from "@/components/VTable";
import { renderPropertyCell, renderDwellingCell } from "@/common/helpers";

export default {
  components: {
    VTable,
  },

  data() {
    return {
      packageFilterText: "",
    };
  },

  computed: {
    ...mapGetters(["packages"]),

    activeUser() {
      return this.$store.getters.user;
    },

    filteredPackages() {
      return this.packages.filter((_package) =>
        _package.label
          .toLowerCase()
          .includes(this.packageFilterText.toLowerCase())
      );
    },
  },

  created() {
    this.$store.dispatch("FETCH_PACKAGES");
  },

  methods: {
    renderPropertyCell,
    renderDwellingCell,

    navToLot(row) {
      this.$router.push(`/live/properties/${row.propertyId}`);
    },

    getLotLabel(row) {
      return row.property.label;
    },

    navToDwelling(row) {
      this.$router.push(`/live/dwellings/${row.dwelling._id}`);
    },

    getDwellingLabel(row) {
      return row.dwelling.label;
    },

    async addPackage() {
      const newPackage = await this.$store.dispatch("ADD_NEW_PACKAGE");
      this.$store.dispatch("CREATE_PACKAGE", newPackage);
      this.editPackage(newPackage._id);
    },

    async clonePackage(_package) {
      const clonedPackage = await this.$store.dispatch(
        "CLONE_PACKAGE",
        _package
      );
      this.$store.dispatch("SAVE_PACKAGE", clonedPackage);
    },

    deletePackage(id) {
      if (confirm("Are you sure?")) {
        this.$store.dispatch("DELETE_PACKAGE", id);
      }
    },

    editPackage(id) {
      this.$router.push(`packages/${id}`);
    },
  },
};
</script>
